import React, { useRef } from 'react';
import { Button, Table, addToast } from '@octano/global-ui';
import { useHistory } from 'react-router-dom';
import { Card } from 'reactstrap';
import useColumns from '../hooks/useColumns';
import { useSurveyEvaluationScalesListLoader } from '../Loaders/SurveyEvaluationScaleListLoader';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import TableEmptyContent from '../../../../components/text/TableEmptyContent';
import { deleteEvaluationScale } from '../api';
import ConfirmModal, { ConfirmModalRef } from './ConfirmModal';
function SurveyEvaluationScaleTable() {
  const history = useHistory();
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_SURVEY_EVALUATION_SCALES,
  );

  const { data, loading, refresh } = useSurveyEvaluationScalesListLoader();

  const confirmModalRef = useRef<ConfirmModalRef>(null);

  const handleRemoveClick = (row: any) => {
    confirmModalRef.current?.openModal(row);
  };

  const handleConfirmDelete = async (row: any) => {
    try {
      const response = await deleteEvaluationScale(row.id);
      if (response.error) {
        addToast({
          icon: 'error',
          color: 'danger',
          text: t('scaleList.deleteError'),
        });
      } else {
        addToast({
          icon: 'success',
          color: 'success',
          text: t('scaleList.deleteSuccess'),
        });
        refresh();
      }
    } catch {
      addToast({
        icon: 'error',
        color: 'danger',
        text: t('scaleList.deleteError'),
      });
    }
  };

  const columnsOthers = useColumns({
    onClickEdit: (row) => {
      history.push(`/survey-evaluation-scales/update/${row.id}`);
    },
    onClickRemove: handleRemoveClick,
    onClickView: (row) => {
      history.push(`/survey-evaluation-scales/view/${row.id}`);
    },
  });

  return (
    <>
      <Card className="m-3 p-3">
        <div className="mb-3">
          <p className="fs-16 text-light mt-3">
            {t('scaleList.descriptionText')}
          </p>
        </div>

        <div className="mb-5">
          <div className="d-flex flex-wrap w-100 align-items-center">
            <Button
              text={t('scaleList.addSurvey')}
              color="primary"
              icon="plus"
              size="md"
              className="mb-3"
              style={{ minWidth: '254px' }}
              onClick={() => history.push('/survey-evaluation-scales/create')}
            />
          </div>
          <Table
            columns={columnsOthers}
            data={data ?? []}
            isLoadingResults={loading}
            loadingView={{
              title: t('scaleList.loadingText'),
              subtitle: t('scaleList.loadingSubText'),
            }}
            noResultsText={
              <TableEmptyContent
                title={t('scaleList.emptyText')}
                subtitle={t('scaleList.emptySubText')}
              />
            }
          />
        </div>
      </Card>

      <ConfirmModal
        ref={confirmModalRef}
        onConfirm={handleConfirmDelete}
        onDecline={() => {}}
      />
    </>
  );
}

export default SurveyEvaluationScaleTable;
